import { render, staticRenderFns } from "./SwimlaneEditor.vue?vue&type=template&id=e3b1964c&scoped=true&"
import script from "./SwimlaneEditor.vue?vue&type=script&lang=js&"
export * from "./SwimlaneEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b1964c",
  null
  
)

export default component.exports